import React, { useState, useContext } from 'react';
import {
    Toolbar,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Grid,
    Fab,
    Typography,
    Button,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { Formik } from 'formik';
import { makeStyles, styled } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';

import SideMenu from '../../components/SideMenu';
import InputSearch from '../../components/InputSearch';
import Alert from '../../components/Alert';
import Popup from '../../components/Popup';
import Input from '../../components/Input';

import api from '../../services/api';
import date from '../../utils/date';
import { PermissionsContext } from '../../providers/Permissions';
import { ListPageHeading, ListTableCard, listResultSubtitle } from '../../components/ListPageLayout';

// eslint-disable-next-line
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export default function CaseTypeList() {
    const classes = useStyles();

    const {
        PermissionWrapper,
        PermissionOneOfWrapper,
    } = useContext(PermissionsContext);

    const [casesTypes, setCasesTypes] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [refresh, setRefresh] = useState(true)
    const [limit, setLimit] = useState(10);
    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [openModalCaseType, setOpenModalCaseType] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [deletingCaseTypeId, setDeletingCaseTypeId] = useState(null);
    const caseType = { name: '' };

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const handleOpenUpload = () => {
        setOpenModalCaseType(true);
    };

    const handleCloseUpload = () => {
        setOpenModalCaseType(false);
    };

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    const handleDelete = (id) => {
        setDeletingCaseTypeId(id);
        setOpenDeletePopup(true);
    }

    async function fetchCasesTypes({ search }) {
        const loadData = async () => {
            try {
                const result = await api.get('/case_type/list', {
                    params: {
                        search,
                        limit,
                        page,
                    },
                });

                const { count, cases_types } = result.data;

                setCasesTypes(cases_types);
                setTotal(count);
            }
            catch (err) {
                console.log(err);
            }
        };

        loadData();
    }

    const changePage = (_, newPage) => {
        setPage(newPage);
    };

    const quantityPerPage = ({ target }) => {
        setLimit(parseInt(target.value, 10));
        setPage(0);
    };

    const deleteCaseType = async () => {
        try {
            setIsDeleting(true);

            const result = await api.post(`/case_type/delete/${deletingCaseTypeId}`);

            const { success } = result.data;

            setIsDeleting(false);

            if (success) {
                setDeletingCaseTypeId(null);
                setOpenDeletePopup(false);
                setRefresh(!refresh);
                setMessage({
                    open: true,
                    variant: 'success',
                    text: `Tipo de caso deletado com sucesso!`,
                });
            }
        }
        catch (err) {
            setIsDeleting(false);
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    }

    const resetForm = formik => {
        formik.resetForm();
    };

    const saveCaseType = async (values, formik) => {
        try {
            const result = await api.post('/case_type/create', values);

            const { name } = result.data;

            await fetchCasesTypes({ search: '' });

            resetForm(formik);

            setMessage({
                open: true,
                variant: 'success',
                text: `Tipo de caso: ${name} cadastrado com sucesso!`,
            });
        }
        catch (err) {
            setMessage({
                open: true,
                variant: 'error',
                text: err.error,
            });
        }
    };

    return (
        <div className={classes.root}>
            <SideMenu />
            <main className={classes.content}>
                <Toolbar />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <ListPageHeading icon="category" title="Lista de Tipos de Caso" />
                    </Grid>
                    
                    <Grid item xs={12}>
                        <ListTableCard
                            title="Tipos de caso cadastrados"
                            subtitle={listResultSubtitle(total)}
                            actions={(
<InputSearch
                            textFieldProps={{
                                placeholder: 'Buscar…',
                            }}
                            request={fetchCasesTypes}
                            pagination={[page, limit, refresh]}
                        />
                            )}
                        >
                            <TableContainer component={Paper}>
                            <Table className={classes.table} size="small" aria-label="access history">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.tableHead}>ID</TableCell>
                                        <TableCell className={classes.tableHead}>Nome</TableCell>
                                        <TableCell className={classes.tableHead}>Criado por</TableCell>
                                        <TableCell className={classes.tableHead}>Data de criação</TableCell>
                                        <PermissionOneOfWrapper
                                            routes={[
                                                "/caso/tipos/deletar/:id",
                                            ]}
                                        >
                                            <TableCell className={classes.tableHead}>Ações</TableCell>
                                        </PermissionOneOfWrapper>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {!!casesTypes && casesTypes.map(caseType => (
                                        <TableRow key={caseType.id}>
                                            <TableCell className={classes.tableBody} component="th" scope="row">
                                                {caseType.id}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {caseType.name}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {caseType.user.name}
                                            </TableCell>
                                            <TableCell className={classes.tableBody}>
                                                {date(caseType.created_at).format('DD/MM/YYYY HH:mm')}
                                            </TableCell>
                                            <PermissionOneOfWrapper
                                                routes={[
                                                    "/caso/tipos/deletar/:id",
                                                ]}
                                            >
                                                <TableCell className={classes.tableBody}>
                                                    <PermissionWrapper route="/caso/tipos/deletar/:id">
                                                        <Button
                                                            type="button"
                                                            variant="contained"
                                                            size="small"
                                                            color="secondary"
                                                            className={classes.actionButton}
                                                            onClick={() => handleDelete(caseType.id)}
                                                        >
                                                            <DeleteIcon style={{ fontSize: 20 }} />
                                                        </Button>
                                                    </PermissionWrapper>
                                                </TableCell>
                                            </PermissionOneOfWrapper>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        </ListTableCard>
                        <TablePagination
                            rowsPerPageOptions={[10, 20, 30]}
                            component="div"
                            count={total}
                            rowsPerPage={limit}
                            page={page}
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            labelRowsPerPage="Registros por página"
                            onChangePage={changePage}
                            onChangeRowsPerPage={quantityPerPage}
                        />
                    </Grid>
                    <Popup
                        openPopup={openDeletePopup}
                        setOpenPopup={setOpenDeletePopup}

                    >
                        <Grid container xs={12} style={{
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '0 3% 2% 3%',

                        }}>
                            <Typography variant='h5'
                                style={{
                                    fontWeight: 'bold',
                                    color: '#9e9e9e'
                                }}
                            >
                                Deseja mesmo deletar este tipo de caso?
                            </Typography>
                            <Grid item style={{
                                marginTop: '50px'
                            }}>
                                <Button
                                    disabled={isDeleting}
                                    variant="contained"
                                    onClick={() => deleteCaseType()}
                                    color="secondary"
                                    endIcon={<DeleteIcon />}
                                >
                                    {isDeleting ? 'Deletando...' : 'Sim, delete este tipo de caso'}
                                </Button>
                            </Grid>

                        </Grid>
                    </Popup>
                </Grid>
                <Popup openPopup={openModalCaseType} setOpenPopup={setOpenModalCaseType} title="Novo tipo de caso" width="min(440px, 100%)" maxWidth="sm" onClose={handleCloseUpload}>
                        <Formik
                            initialValues={caseType}
                            onSubmit={saveCaseType}
                        >
                            {({ values, handleChange, handleSubmit, isSubmitting, setFieldValue }) => (
                                <form id="case-type-create" onSubmit={handleSubmit}>
                                    <Input
                                        label="Nome"
                                        textFieldProps={{
                                            name: 'name',
                                            id: 'name',
                                            placeholder: 'Nome do campo',
                                            onChange: handleChange,
                                            value: values.name,
                                            fullWidth: true,
                                            required: true,
                                        }}
                                    />

                                </form>
                            )}
                        </Formik>
                    <Grid container justify="flex-end" spacing={1} style={{ marginTop: 16 }}>
                        <Grid item><Button variant="outlined" onClick={handleCloseUpload}>Cancelar</Button></Grid>
                        <Grid item><Button color="primary" variant="contained" type="submit" form="case-type-create" style={{ borderRadius: 9, minHeight: 44, minWidth: 140, fontWeight: 700, textTransform: 'none' }}>Salvar dados</Button></Grid>
                    </Grid>
                </Popup>
                <PermissionWrapper route="/caso/tipos/criar">
                    <Fab
                        color="primary"
                        aria-label="add"
                        className={classes.fabButton}
                        onClick={handleOpenUpload}
                    >
                        <AddIcon />
                    </Fab>
                </PermissionWrapper>
                {!!message.open && (
                    <Alert
                        open={message.open}
                        autoHideDuration={6000}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                        severity={message.variant}
                        onClose={closeMessage}
                    >
                        {message.text}
                    </Alert>
                )}

            </main>
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        marginBottom: theme.spacing(6),
        marginTop: theme.spacing(5),
    },
    title: {
        color: grey[700],
        fontSize: 28,
    },
    table: {
        minWidth: 500,
        width: '100%',
    },
    tableHead: {
        textAlign: 'center',
        textTransform: 'uppercase',
        color: grey[500],
    },
    tableBody: {
        color: '#374151',
        padding: '14px 10px',
        textAlign: 'center',
        fontSize: 14,
        fontWeight: 600,
        borderBottom: '1px solid #eef1f5',
    },
    actionButton: {
        margin: theme.spacing(0, .5),
        padding: theme.spacing(.5, 0),
        minWidth: 30,
        borderRadius: 9,
    },
    fabButton: {
        position: 'fixed',
        bottom: 0,
        right: 0,
        margin: theme.spacing(3),
    },
}));
